import React from "react";
import Topbar from "../../components/topbar/topbar";
import Footer from "../../components/footer/footer";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import "./index.css";
export default function PaymentCancel() {
   const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    // check if current route is /payment-cancelled
    if (location.pathname === "/payment-cancelled") {
      navigate("/"); // redirect to main route
    }
  };
  return (
    <>
      <Topbar />
       <div className="thankyou-container">
      <div className="thankyou-card">
        <img
          src="/images/Union-icon.png"
          alt="Union Icon"
          className="thankyou-icon"
        />

        <h2>Payment Cancelled!
</h2>

        <p className="thankyou-text">
         Your Payment cancelled. Please try again or contact us for any issue.
        </p>

        <button className="rounded-btn"  onClick={handleClick}>Click here</button>
      </div>
    </div>

    </>
  );
}
